
/* eslint-disable @typescript-eslint/no-shadow */
export namespace OpenEndedGraphTypeV1 {
  export enum OpenEndedGraphTypeV1 {
    WORD_CLOUD = "WORD_CLOUD",
    NONE = "NONE",
  }

  export interface OpenEndedGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: OpenEndedGraphTypeV1DTO): OpenEndedGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidOpenEndedGraphTypeV1Error(
        `Invalid DTO ${dto} provided for OpenEndedGraphTypeV1.OpenEndedGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "WORD_CLOUD":
        return OpenEndedGraphTypeV1.WORD_CLOUD;
      case "NONE":
        return OpenEndedGraphTypeV1.NONE;
      default:
        throw new InvalidOpenEndedGraphTypeV1Error(
          `Case ${dto.case} is not valid case of OpenEndedGraphTypeV1.OpenEndedGraphTypeV1`
        );
    }
  };

  export const toDTO = (openEndedGraphTypeV1: OpenEndedGraphTypeV1): OpenEndedGraphTypeV1DTO => {
    const enumDTO = {
      case: OpenEndedGraphTypeV1[openEndedGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidOpenEndedGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedGraphTypeV1Error";
  }
}
export class InvalidOpenEndedGraphTypeV1WordCloudError extends InvalidOpenEndedGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedGraphTypeV1WordCloudError";
  }
}

export class InvalidOpenEndedGraphTypeV1NoneError extends InvalidOpenEndedGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedGraphTypeV1NoneError";
  }
}
